<template>
  <div class="home">

    <div class="greyZ lighten-4 pt-6 pt-md-12 mt-16" >
      <v-container>
        <v-row>
          <v-col cols="12" class="text-center">
            <h1 class="subtitle mb-6">Challenge your team!</h1>
            <h3 class="headline">
              <!-- Create connected corporate fitness events to get more happy employees. Happy and fit employees are more productive, less stressed, and reduce healthcare costs! -->
              Fit and happy employees are more productive and less stressed.<br/>
              Why wait? Let's Go!
            </h3>
            <p class="mb-0 mt-8">
              <v-btn class="" color="primary" :to="{name:'startTrial'}">Start Free Trial</v-btn>
              <v-btn class="ms-4" color="primary" text to="/contact">Contact Us</v-btn>
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="mt-8 pb-0">
            <div class="text-muted align-center mb-2">Trusted by 1,000+ organizations globally:</div>
            <v-slide-group v-model="slideCustomerIndex" :show-arrows="false">
              <v-slide-item v-for="(item, idx) in customers" :key="idx">
                <div class="me-4" style="align-content: end; height: 50px;">
                  <img :src="`https://sodisp.imgix.net/web/customers/${item.id}-white.png?w=100`" :alt="item.name" class="d-inline-block" :style="`max-width:100px; max-height: 50px; filter:invert(30%);`"/>
                </div>
              </v-slide-item>
            </v-slide-group>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <v-divider />

    <div class="grey lighten-4 py-6 py-md-12 text-center">
      <div class="container">
        <v-row>
          <v-col cols="12">
            <p>Use {{ tenant.name }} to launch your next fitness or wellbeing challenge. Our platform connects with all popular devices and offers the flexibility you need to start a successful and engaging fitness challenge. Join us in our mission to get more people move more!</p>
          </v-col>
        </v-row>
      </div>
    </div>

    <v-divider />

    <div class="grey lighten-3 py-6 py-md-12 text-center">
      <div class="container">
        <v-row>
          <v-col cols="12" md="12">
            <h2 class="text-center mb-4">Why Choose {{ tenant.name }}</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="4">
            <v-icon size="50">fal fa-shield</v-icon>
            <h3 class="mt-4 mb-2">Proven Partner</h3>
            <!-- <p>We work with organizations like NASA, Ferrero, and many more to move their global workforces.</p> -->
            <p>Our platform, security and experience allows your organization to host inclusive and engaging challenges.</p>
          </v-col>
          <v-col cols="12" sm="4">
            <v-icon size="50">fal fa-paint-roller</v-icon>
            <h3 class="mt-4 mb-2">Make it Yours</h3>
            <p class="">Your challenge, your brand, your rules! Use our ready-to-go challenges or we can help you launch a custom setup.</p>
          </v-col>
          <v-col cols="12" sm="4">
            <v-icon size="50">fal fa-rocket</v-icon>
            <!-- <h3 class="mt-4 mb-2">No Fuss Setup</h3> -->
            <h3 class="mt-4 mb-2">Hassle-Free Launch</h3>
            <p>Our quick turnaround, transparent pricing, and easy to use dashboard will get you going in no time.</p>
          </v-col>
        </v-row>
      </div>
    </div>

    <v-divider />

    <div class="grey lighten-4 py-6 py-md-12">
    <v-container class="">
      <v-row>
        <v-col cols="12" class="pb-0">
          <h2 class="title text-center mb-4">Our Key Capabilities</h2>
        </v-col>
        <v-col cols="12" sm="6" class="py-0"> 
          <SmallButton title="Mobile App" icon="fa-mobile" class="mb-4" to="/get" />
          <SmallButton title="Fitness Device Integrations" icon="fa-watch-fitness" class="mb-4" to="/solutions/integrations/fitness-trackers" />
          <SmallButton title="Team Leaderboards" icon="fa-users" class="mb-4" to="/product/benefits/teams-collective" />
          <SmallButton title="Co-branding &amp; Customizability" icon="fa-paint-roller" class="mb-4" to="/product/benefits/full-customization" />
        </v-col>
        <v-col cols="12" sm="6" class="py-0"> 
          <SmallButton title="Security and Data Privacy" icon="fa-shield" class="mb-4" to="/product/benefits/security-data-privacy" />
          <SmallButton title="Global Availability" icon="fa-globe" class="mb-4" to="/product/benefits/global-availability" />
          <SmallButton title="Inclusive &amp; Personalizable" icon="fa-bullseye" class="mb-4" to="/product/benefits/personal-goals" />
          <SmallButton title="Quick Turnaround Time" icon="fa-rocket" class="mb-4" to="/pricing/support-plans" />
        </v-col>
      </v-row>
      <p class="mb-0 text-center">
        <v-btn color="primary" text to="/product/benefits">More Benefits</v-btn>
      </p>
    </v-container>
    </div>

    <v-divider />

    <div class="grey lighten-3 py-6 py-md-12">
      <div class="container">
        <v-row>
          <v-col cols="12" md="12">
            <h2 class="title">For all Step, Fitness, and Wellbeing Challenges!</h2>
            <p class="">
              Whichever type of fitness challenge you want to start, we've got you covered! We can auto-sync with all popular fitness trackers and phones.
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="4">
            <BigButton elevated title="Step Challenges" text="Most popular: fully customizable step challenges" href="/product/challenges/step-challenges" icon="fal fa-shoe-prints" />
          </v-col>
          <v-col cols="6" sm="4">
            <BigButton elevated title="Wellbeing" text="Focus on all-round wellbeing of your employees." href="/product/challenges/well-being-challenges" icon="fal fa-spa" />
          </v-col>
          <v-col cols="6" sm="4">
            <BigButton elevated title="Time-based" text="Everyone can join the fun and all activities count!" href="/product/challenges/time-based-challenges" icon="fal fa-stopwatch" />
          </v-col>
          <v-col cols="6" sm="4">
            <BigButton elevated title="Distance-based" text="Make every km/mile count! Either in one go, or cumulative distance." href="/product/challenges/distance-challenges" icon="fal fa-ruler" />
          </v-col>
          <v-col cols="6" sm="4">
            <BigButton elevated title="Build-Your-Own" text="You dream it, we can deliver it! Be in full control of the rules." href="/challenges/custom" icon="fal fa-tools" />
          </v-col>
          <v-col cols="6" sm="4">
            <BigButton elevated title="See all" :text="`Explore all ${templates?templates.length : ''} different and unique challenges`" href="/challenges/" icon="fal fa-ellipsis-h" />
          </v-col>
        </v-row>
        <v-col cols="12" md="12" class="text-center">
          <v-btn text color="primary" to="/start-trial">Start Free Trial</v-btn>
        </v-col>
      </div>
    </div>

    <v-divider style="border-color:white;" />

    <div class="green white--text py-6 py-md-12">
      <div class="container">
        <v-row>
          <v-col cols="12" md="12">
            <h1 class="subtitle">Trusted By Global Brands</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-card to="/blog/nasa-moves-2024">
              <v-card-title>NASA</v-card-title>
              <v-card-text>
                We help NASA to keep increasing the engagement of their annual step challenge. 
                
                <br/><br/>As one participants puts it:
                "Great group activity! It's a fantastic motivational program for getting NASA employees moving."
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card to="/blog/case-study-the-university-of-southern-california">
              <v-card-title>University of Southern California</v-card-title>
              <v-card-text>
                The focus of this event was to encourage participants to share their activities with the group. This resulted in an average of 4.1 selfie shared per participant and them receiving an average of 13.4 likes.
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card to="/blog/case-study-lenovo">
              <v-card-title>Lenovo</v-card-title>
              <v-card-text>
                Together with CorporateFitness.app and WizeHive, Lenovo was able to successfully run the “Walk for Water” event to raise nearly $100,000 towards resources and water wells between World Water Day and Earth Day.
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <h1 class="title">Scale to success</h1>
            <p class="mb-0">From the simplest step challenges to the most complex competitions. From 10 participants to 10,000+. We have the infrastructure, security measures and experience to fit your organization's needs.</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <p class="mb-0 mt-4">
              <v-btn class="mb-4" color="white" outlined href="/resources/case-studies">More Case Studies</v-btn>
              <v-btn class="me-4" color="white" text href="/contact">Talk to Us</v-btn>
            </p>
          </v-col>
        </v-row>
      </div>
    </div>

    <v-divider />

    <div class="mt-0 white lighten-2 py-6 py-md-12">
      <div class="container pb-0">
        <v-row>
          <v-col class="pb-4">
            <h1 class="headline text-center">How {{ tenant.name }} Works</h1>
            <p class="mb-0 mt-4">
              <VideoEmbed videoId="LyoxH7OLMb0" />
            </p>
          </v-col>
        </v-row>
      </div>
    </div>

    <v-divider style="border-color:white;" />

    <div class="mt-0 grey lighten-2 py-6 py-md-12">
      <div class="container pb-0">
        <v-row>
          <v-col class="pb-4">
            <h1 class="headline">Explore our ready-to-go challenges</h1>
            <v-slide-group
              v-if="templates && templates.length"
              show-arrows
            >
              <v-slide-item v-for="(item, idx) in templates" :key="idx">
                <EventTemplateCard :item="item" compact width="200" class="ma-4" />
              </v-slide-item>
            </v-slide-group>
            <p class="mb-0 mt-4">
              Follow out step-by-step guided onboarding process and go live in minutes.
            </p>            
            <p class="mb-0 mt-4">
              <v-btn class="me-4" color="primary" outlined href="/challenges">Explore All</v-btn>
              <v-btn class="me-4" color="primary" text href="/challenges/custom">Build Your Own</v-btn>
            </p>            
          </v-col>
        </v-row>
      </div>
    </div>

    <v-divider />

    <div class="mt-0 grey lighten-3 py-6 py-md-12">
      <div class="container pb-0">
        <v-row>
          <v-col cols="12" md="6" class="">
            <h1 class="headline mb-4">We Help you Succeed</h1>
            <p>
              We're driven to ensure that the types of challenges you envision should be fun and engaging for all participants, including the organizers. And that further, they should be the full-time jobs of no one, especially the organizers.
            </p>
            <div>
              <h4>Communication Hub</h4>
              <p>Use our email templates, quick-start guides and posters to quickly launch your event.</p>
            </div>
            <div>
              <h4>We have your back</h4>
              <p>Chose between self-service or fully-managed support options to fit your needs.</p>
              <p>We have hosted more than {{ siteData.stats.total_events | int }} events so far for customers around the globe. We will also help you succeed.</p>
            </div>
            <v-btn outlined class="me-4" color="primary" href="/pricing/support-plans">Explore Support Plans</v-btn>

          </v-col>
          <v-col cols="12" md="6" class="">
            <img src="/illustrations/about_sodisp.svg" width="100%" />
          </v-col>
        </v-row>
      </div>
    </div>

    <v-divider />

    <div class="mt-0 grey lighten-4 py-6 py-md-12 text-center">
      <div class="container pb-0">
        <v-row>
          <v-col cols="12" md="6" class="">
            <h1 class="headline mb-4">Our Results</h1>
            <!-- <h1 class="headline mb-4">The Effect We Have</h1> -->
            <p>
              It's in our DNA to motivate people to move more and get healthier. Here are a few interesting metrics we can help you achieve for your team.
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="4">
            <BigButton elevated title="A" text="" />
          </v-col>
          <v-col cols="6" sm="4">
            <BigButton elevated title="B" text="" />
          </v-col>
          <v-col cols="6" sm="4">
            <BigButton elevated title="C" text="" />
          </v-col>
        </v-row>
      </div>
    </div>
<!--  
    <v-divider style="border-color:white;" />

    <div id="page-customers" class="mt-0 blob-bg white--text">
      <div class="container pb-0">
        <v-row>
          <v-col class="pb-4">
            <h1 class="headline">Trusted by over {{ siteData.stats.total_orgs | int }} global corporations</h1>
            <p>
              {{tenant.name}} is used by world-renowned corporations to host their connected fitness events. Some of our key partners are:
            </p>
            <SectionCustomers :showcase="false" corporate/>
          <p class="mb-0 mt-4">
            So far, <strong>{{siteData.stats.total_events | int}}</strong> events have been created already by {{siteData.stats.total_orgs | int }} organizations. Join today!
          </p>
          <p class="mb-0 mt-4">
            <v-btn class="mr-4 mb-4" color="white" href="/start-trial">Start Free Trial</v-btn>
            <v-btn class="mb-4" color="white" outlined href="/contact">Contact Us</v-btn>
          </p>

          </v-col>
        </v-row>
      </div>
    </div>

    <v-divider style="border-color:white;" /> -->
    <v-divider />

    <div class="mt-0 grey lighten-2 py-6 py-md-12">
      <div class="container pb-0">
        <v-row>
          <v-col class="pb-4 text-center">
            <h1 class="headline mb-4">Frequently Asked Questions</h1>
            <v-expansion-panels>
              <v-expansion-panel
                v-for="(item,i) in faqs"
                :key="i"
              >
                <v-expansion-panel-header>{{ item.q }}</v-expansion-panel-header>
                <v-expansion-panel-content>{{ item.a }}</v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
        <p class="mb-0 mt-4 align-center">
          <v-btn outlined color="primary" to="/start-trial" class="me-4">Start Free Trial</v-btn>
          <v-btn text color="primary" to="/contact">Contact Us</v-btn>
        </p>

      </div>
    </div>
 
 
    <v-divider style="border-color:white;" />

    <div class="green white--text py-6 py-md-12">
      <div class="container">
        <v-row>
          <v-col cols="12" md="12" class="text-center">
            <h1 class="subtitle">Go Live Today!</h1>
            <p>Create your event and launch your event within the hour!</p>
            <p class="mb-0 mt-4">
              <v-btn class="mr-4 mb-4" color="white" to="/start-trial">Start Free Trial</v-btn>
              <v-btn class="mb-4" color="white" outlined to="/contact">Contact Us</v-btn>
            </p>
          </v-col>
        </v-row>
      </div>
    </div>

    <v-divider style="border-color:white;" />

  </div>
  
</template>

<script>
import axios from "axios";
import SectionIntegrations from "@/components/SectionIntegrations.vue";
import SectionCustomers from "@/components/SectionCustomers.vue";
import EventTemplateGrid from '@/components/templates/EventTemplateGrid.vue'
import EventTemplateCard from '@/components/templates/EventTemplateCard.vue'
import VideoEmbed from "@/components/VideoEmbed";
import BigButton from "@/components/BigButton";
import SmallButton from "@/components/SmallButton";
import siteData from '@/data/site.json'
import tenants from '@/data/tenants.config'
import assetsService from "@/services/assetsService";
const tenant = tenants.current();

export default {
  name: "home",
  components: {
    SectionIntegrations,
    SectionCustomers,
    EventTemplateGrid,
    EventTemplateCard,
    VideoEmbed,
    BigButton,
    SmallButton,
  },
  data() {
    return {
      tenant: tenant,
      siteData: siteData,
      currency: 'USD',
      userCount: 10,
      templates: null,
      customers: siteData.customers.filter(x => x.corporate),
      slideCustomerIndex: 0,
      slideInterval: null,
      faqs: [
        {
          "q": "Which fitness trackers and apps do you support?",
          "a": "TBD"
        },
        {
          "q": "Do you support manual entry? Can manual entry be turned off?",
          "a": "TBD"
        },
        {
          "q": "How quick can we go live?",
          "a": "TBD"
        },
        {
          "q": "What security measures are in place to protect employee data?",
          "a": "TBD"
        },
        {
          "q": "Is there a free trial available?",
          "a": "TBD"
        },
        {
          "q": "Do you provide support and managed services?",
          "a": "TBD"
        },
        {
          "q": "Is there an admin dashboard available?",
          "a": "TBD"
        },
        {
          "q": "Can we co-brand the app with our logo and brand identity?",
          "a": "TBD"
        },
        {
          "q": "Do you support teams? What options are available?",
          "a": "TBD"
        },
        {
          "q": "Is there an integration with Slack or Microsoft Teams?",
          "a": "TBD"
        },
      ]
    };
  },
  async mounted() {
    this.loadData();
    //this.slideInterval = setInterval(() => (this.slideCustomerIndex++) % this.customers.length, 2000);
    this.slideInterval = setInterval(() => this.slideCustomerIndex > this.customers.length ? this.slideCustomerIndex = 0 : this.slideCustomerIndex++, 2000);
  }, 
  beforeDestroy () {
    clearInterval(this.slideInterval);
  },
  methods: {
    async loadData() {
      this.templates = (await assetsService.getEventTemplates()).data.data;//.filter(x => x.featured);
    }, 
  }, 
  computed: {
    perUserFee() {
      var plan = this.siteData.products.find(x=>x.key=='product-event-basic')
      if (!plan) {
        return null;
      }
      return plan.prices[this.currency];
    },
  }
};
</script>

<style lang="scss" scoped>
  .features {
    i { background-color: #008F5822; border-radius: 50%; padding: 15px; margin-top: 15px; }
    .plus {
      margin: 0 20px; line-height: 30px;
      color: #008F58;
    }
    h4 { margin-top: 8px; }
  }

  /* CLS improvements:  */
  #page-hero { min-height: 358px;}
  #page-customers { min-height: 340px;}
  #page-integrations { min-height: 436px;}
  .cta-bar { min-height: 332px;}

  .small { font-size: 75%; display: inline-block; text-align: left;}
  .large { font-size: 200%;}
  .large + .small { margin-left: 5px; }
  .v-sheet.dotted, button.dotted { border: 2px dotted #ccc; border-radius: 4px; background: white; }

  @media (max-width: 500px) {
    /*#page-hero { min-height: 750px;}*/
    #page-customers { min-height: 560px;}
    #page-integrations { min-height: 625px;}
    .cta-bar { min-height: 332px;}
  }</style> 